import type { EditorReadyFn } from '@wix/yoshi-flow-editor';

import { globalAppState } from '../../editor/services';
import {
  monitoredTransactionFactory,
  toMonitored,
} from '../../editor/services/monitor';
import { uninstallIfProvisionedWithoutMembersArea } from '../common/uninstallation';
import { maybeSanitizeData } from './data-sanitizer/data-sanitizer';
import { installMemberPage } from './installation';
import { addEventsListeners } from './listeners';
import { isProfilePageBobValid } from './utils';

export const monitoredEditorReady: EditorReadyFn = (
  editorSDK,
  appDefinitionId,
  options,
  flowAPI,
) =>
  toMonitored('editorReady', async () => {
    if (!options.firstInstall) {
      const { uninstalled } = await uninstallIfProvisionedWithoutMembersArea(
        editorSDK,
      );
      if (uninstalled || !(await isProfilePageBobValid(editorSDK))) {
        return;
      }

      await maybeSanitizeData(editorSDK);
    }

    if (options.firstInstall) {
      const monitoredTransaction = monitoredTransactionFactory(editorSDK);

      await monitoredTransaction('install', () =>
        installMemberPage({
          editorSDK,
          options,
          appDefinitionId,
          flowAPI,
        }),
      );
      globalAppState.disableRoutesRefresh();
    }

    await addEventsListeners(editorSDK, flowAPI);
  });
